import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import { Col, Row} from 'reactstrap';
import DefaultModal from "../invoice/DefaultModal";
import {ACCESS_TOKEN, EntegratorConf} from "../../constants";
import Alert from 'react-s-alert';
import {EntegratorIdentifiers} from "../../helper/enums";

class DirectingToOtherPortalModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saveLoading: false
        };
        this.closeModal 			= this.closeModal.bind(this);
        this.followOtherPortal = this.followOtherPortal.bind(this);
    }


    closeModal() {
        this.props.listener();
    }

    redirectToExternalURL = (idToken) => {
        let staticUrl;
        if(EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) {
            staticUrl = 'https://crm.kolaysoft.com.tr';
        }
        if(EntegratorIdentifiers.SMART === EntegratorConf.identifier) {
            staticUrl = 'https://crm.smartdonusum.com';
        }

        if(EntegratorIdentifiers.MBT === EntegratorConf.identifier) {
            staticUrl = 'https://crm.mbtfatura.com.tr';
        }

        const newWindow = window.open();
        newWindow.location.href =staticUrl+`/access/${idToken}/my-requests`;
    }


    followOtherPortal () {
        const idToken = localStorage.getItem(ACCESS_TOKEN);
        if (!idToken) {
            Alert.error("Token bulunamadığından diğer portala geçiş yapılamaz!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        } else {
            this.closeModal();
            this.redirectToExternalURL(idToken);
        }
    }



    render() {
        return (
            <DefaultModal
                disabled={this.state.saveLoading}
                isOpen={this.props.modal}
                title="Öneri/Talep Bildirimi Yeni Portal Yönelimi"
                size="lg"
                confirmBtnText={"EVET"}
                cancelBtnText="HAYIR"
                onConfirm={this.followOtherPortal}
                onCancel={this.closeModal}>
                <Col sm="12">
                    <Col sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
                        <Row style={{paddingTop:"10px"}}>
                            <Col sm="12" style={{paddingTop:"10px"}}>
                                <p><h4>Başka bir portala yönlendirilmek üzeresiniz.Devam etmek istediğinizden emin misiniz?</h4></p>
                            </Col>
                        </Row>
                    </Col>
                </Col>
            </DefaultModal>
        );
    }
}

export default DirectingToOtherPortalModal;

